/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './PassesFeaturedPromo.scss';

import { Button } from 'sarsaparilla';

import backgroundImageSrc from './images/passes-featured.webp';

export function PassesFeaturedPromo() {
    return (
        <div className="nav--passes-featured-promo">
            <div className="image-group">
                <img src={backgroundImageSrc} alt="" className="image" />
            </div>

            <div className="overlay" />
            <div className="overlay-shader" />

            <div className="content">
                <h2>Passes</h2>
                <p>
                    Enjoy the convenience of purchasing a pass ahead of time to cover
                    entrance or standard amenity (day-use) fees for your trips.
                </p>

                <Button
                    className="learn-more-button"
                    appearance="tertiary-white"
                    aria-label="Learn more about interagency and site passes"
                    href="/pass/"
                    gaReportName="Featured promo for passes"
                    gaReportCreative="featured promo for passes"
                    gaReportPosition="HomePage"
                    shouldReportToGA
                >
                    Learn More
                </Button>
            </div>
        </div>
    );
}
